import { createSelector } from 'reselect';

import { assetsObsoleteTypesOptions, assetsTypesOptions } from 'constants/options';

import { selectLoanApplication } from './loanApplication.selectors';

const selectAssets = createSelector(selectLoanApplication, ({ assets }) => assets);

const selectAssetsValues = createSelector(selectAssets, Object.values);

export const selectAssetsWithTypeAndAmount = createSelector(selectAssetsValues, assets =>
  assets.map(asset => {
    const cashOrMarketValue = asset.cashOrMarketValue || 0;
    const assetTypeName = [...assetsTypesOptions, ...assetsObsoleteTypesOptions].find(
      ({ value }) => value === asset.type,
    )?.name;

    return {
      ...asset,
      typeAndAmount: `${assetTypeName} $${cashOrMarketValue}`,
    };
  }),
);
